import {Component} from '@angular/core';

@Component({
  selector: 'app-download-expired',
  templateUrl: './download-expired.component.html',
  styleUrls: ['./download-expired.component.css']
})
export class DownloadExpiredComponent {
  homepage() {
    location.href = new URL(location.href).origin;
  }
}
